"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SsiFooter = SsiFooter;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _WarningAlert = require("./WarningAlert");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function SsiFooter(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ssi-footer"
  }, /*#__PURE__*/_react["default"].createElement(_WarningAlert.WarningAlert, null, props.ssiLabels.ssiFooter));
}

SsiFooter.propTypes = {
  ssiLabels: _propTypes["default"].instanceOf(Object).isRequired
};